module.exports = __webpack_public_path__ + "static/img/title_2_blue@2x.86299e5c.png";